"use client";

import { ReactNode } from "react";
import NavigationSectionComponent, {
  INavigationSectionComponentProps,
} from "@template/blocks/NavigationSection/component";
import FooterSectionComponent, {
  FooterSectionComponentProps,
} from "@template/blocks/FooterSection/component";
import * as S from "./styles.ts";

interface Props {
  children: ReactNode;
  navigation: INavigationSectionComponentProps;
  footer: FooterSectionComponentProps;
}

const PageLayout: React.FC<Props> = ({ children, navigation, footer }) => {
  return (
    <>
      <NavigationSectionComponent {...navigation} />
      <S.ContentContainer>{children}</S.ContentContainer>
      <FooterSectionComponent {...footer} />
    </>
  );
};

export default PageLayout;
